export const ITEMS = 'shoppingListItems'
export const USER_ID = 'userId'
export const LIST_ID = 'listId'
export const SESSION = 'session'
